import { __require as requireImplementation } from './implementation.js';
import { __require as requireDefineProperties } from '../define-properties/index.js';

var polyfill;
var hasRequiredPolyfill;

function requirePolyfill () {
	if (hasRequiredPolyfill) return polyfill;
	hasRequiredPolyfill = 1;

	var implementation = requireImplementation();

	var supportsDescriptors = requireDefineProperties().supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;

	polyfill = function getPolyfill() {
		if (supportsDescriptors && (/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (
				descriptor
				&& typeof descriptor.get === 'function'
				&& 'dotAll' in RegExp.prototype
				&& 'hasIndices' in RegExp.prototype
			) {
				/* eslint getter-return: 0 */
				var calls = '';
				var o = {};
				Object.defineProperty(o, 'hasIndices', {
					get: function () {
						calls += 'd';
					}
				});
				Object.defineProperty(o, 'sticky', {
					get: function () {
						calls += 'y';
					}
				});

				descriptor.get.call(o);

				if (calls === 'dy') {
					return descriptor.get;
				}
			}
		}
		return implementation;
	};
	return polyfill;
}

export { requirePolyfill as __require };
